$(".video-container[data-video-url]:not([data-video-type])").each(
  function () {
    var url = $(this).data("video-url");

    if (url.indexOf(".mp4") > -1) {
      $(this).attr("data-video-type", "mp4");
    }

    if (url.indexOf("vimeo.com") > -1) {
      $(this).attr("data-video-type", "vimeo");
      $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
    }

    if (url.indexOf("youtu.be") > -1 || url.indexOf("youtube.com") > -1) {
      $(this).attr("data-video-type", "youtube");

      if (url.indexOf("v=") > -1) {
        $(this).attr(
          "data-video-id",
          url.split("v=").pop().split("&")[0]
        );
      } else {
        $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
      }
    }
  }
);
  
/* 
Check if the user is on a mobile device
*/
function isMobileDevice() {
  return /Mobile|iPhone|iPad|Android|Windows Phone|BlackBerry|Opera Mini/i.test(navigator.userAgent);
}


$(document).ready(function(){
 
  // Show the PDF container on catalogue click
  $('.catalogue-column .multicolumn-card__image-wrapper').on('click', function(){
    $('.pdf-container').show();
  })

  // Hide the PDF container on close
  $('.close').on('click', function(){
      $(this).parent().hide();
  })


  // Set the product colors containers placement on archive page
  var card_prod_height = $('.grid__item .card__media').height();
  var inner_item = document.querySelector('.grid__item .card__inner');
  var inner_item_height;
  if (inner_item) {
    inner_item_height = inner_item.offsetHeight-60;
  }
  card_prod_height = card_prod_height - 40;

  // Replace '.grid__item' with the actual class name or ID you're targeting
  var gridItem = document.querySelector('.grid__item');
  
  if (gridItem) {
    var card_prod_height = $('.grid__item .card__media').height();

    if ( isMobileDevice() || window.innerWidth < 500) {
        card_prod_height = card_prod_height;
        console.log(inner_item_height);
        
        var elements = document.querySelectorAll('.version-two-color');
        elements.forEach(function(element) {
          the_prod.setAttribute('style', "top:"+inner_item_height+'px !important;');
        });

      console.log('MOBILE');
    } else {
        
      $('.version-two-color').css('top', inner_item_height+'px');

      console.log('BIG DEVICE');
    }
  } 

  // Changes the product details on color change on collection page
  setTimeout(() => {
    $('.color-selection.collection a img, .color-selection.collection .color_swatch').on('click', function(){
      console.log('CHANGE URL');
      var prodUrl = jQuery(this).attr('data-url');
      var prodImage = jQuery(this).attr('data-img');
      var newPrice = $(this).attr('data-price');
      var oldPrice = $(this).attr('data-old-price');
      var newTitle = $(this).attr('data-title');

      console.log('Title: '+newTitle);

      newPrice = parseFloat(newPrice).toFixed(2);
      oldPrice = parseFloat(oldPrice).toFixed(2);
      
      // Change the image 
      $(this).parents('li.grid__item').find('.card__content .card__heading a').attr( 'href', $(this).data('url') );
      $(this).parents('li.grid__item').find('.card__media img').attr( 'src', $(this).data('img') );
      $(this).parents('li.grid__item').find('.card__media img').attr( 'srcset', $(this).data('img') );
      
      // Set the new selecteed class
      $(this).parent().parent().find('a.selected').removeClass('selected');
      $(this).parent().addClass('selected');

      // Change the text
      $(this).parents('li.grid__item').find('.full-unstyled-link').text(newTitle);

      // Change the price
      $(this).parents('li.grid__item').find('.card-information span.price-item.price-item--old').html('<span class="price-item price-item--old">'+oldPrice+' kr</span>');
      $(this).parents('li.grid__item').find('.card-information span.price-item.price-item--regular').html('<span class="price-item price-item--regular">'+newPrice+' kr</span>');
    });
  }, 1200);
 
  // Create hover function for mega-menu
  // $('details.mega-menu').hover(
  //   function() {
  //     $( this ).attr( 'open', true );
  //   }, function() {
  //     $( this ).removeAttr('open');
  //   }
  // );


  // Render the products colors on collection page
  //render_reference_products();
  //get_current_collection_sold_out_prodcuts();

});
 
// Function to get cookie value by name
function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) return decodeURIComponent(cookieValue);
  }
  return null;
}

// Function to set a cookie with a specified expiration time (e.g., 30 days)
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
}




// Function that renders the product colors on the collection page 
function render_reference_products(){
  console.log('Info: Render product');
  // var product_handle_objects = get_reference_products();

  $('li.grid__item').each(function(){
    var colorContainer      = $(this).find('.color-selection');
    var main_id             = $(colorContainer).attr('data-main-id');
    var selected_handle     = $(colorContainer).attr('data-selected-handle');
    var color_version       = $(colorContainer).attr('data-color-version-two');
    var check_offer_number  = $(this).get(0).hasAttribute('data-offer-number') ? parseInt( $(this).attr('data-offer-number') ) : 0;
    
    var handleArr = [];
    handleArr.length = 0;
    handleArr.push($(colorContainer).attr('data-selected-handle')+'|'+$(colorContainer).attr('data-related-handles') );
    
    if( handleArr == null ){
      console.log('Info: No products in stored data 1');
      return;
    }else{
      console.log('Info: Reindexing products 1');
      //jQuery(colorContainer).html('');
    }
 
    var splitCookie = handleArr[0].split('|');
    var list = jQuery(colorContainer);
    var productArr = [];
    productArr.length = 0;
    // Get normal productinfo
    
    for( i = 0; i < splitCookie.length; i++ ){
      if (typeof splitCookie[i] === 'string') {
        let parts = splitCookie[i].split('_');
        let url = '/products/' + parts[0] + '.js';

        jQuery.getJSON(url, function(product) {

          let prod_obj ={
           prod: product,
           color: parts[1]
          }
           productArr.push(prod_obj);
         })
         .done(function(product) {
           console.log( "Success" );
           
         })
         .fail(function() {
           console.log( "error: No handle found" );
         });
      }

      
    }

    setTimeout(() => {
      if( productArr.length == 0 ){
          console.log('Info: No products in stored data');
          return;
      }else{
          console.log('Info: Reindexing products');
      }
      
      productArr.forEach(element => {
        var the_prod    = element.prod; 
        var color_image  = element.color;

        // Check tags to see what color the product is.
        // This is used if no color is set in metafields
        // This will need to be dynamic in the future, when PIM is in engish

      
        if(!color_image){
          for( var tag of the_prod.tags ){
            var color_group;
            if( tag.toLowerCase().indexOf('bicolor') > 0 || tag == 'Metal_Bicolor' || tag == 'Bicolor'){
              color_image =  color_version ? 'linear-gradient(54deg, rgba(214,214,214,1) 49%, rgba(216,200,151,1) 49%)' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_bicolor.png';
              color_group = 'cw_bicolor';
              break;
            }
            if(tag.toLowerCase().indexOf('sølv') > 0 ||  tag == 'Metal_Sterlingsølv' || tag == 'Sterlingsølv' || tag.toLowerCase().indexOf('silber') > 0){
              color_image =  color_version ? '#d6d6d6' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_silver.png';
              color_group = 'cw_silver';
              break;
            }
            if( tag.toLowerCase().indexOf('Rosa ') > 0 ||  tag == 'Metal_Rosa' || tag == 'Rosa' || tag == 'Rosaforgyldt' || tag.toLowerCase().indexOf('rosa') > 0){
              color_image =  color_version ? '#f1d2c5' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_rosa.png';
              color_group = 'cw_rosa';
              break;
            }
            if( tag.toLowerCase().indexOf('forgyldt') > 0 ||  tag == 'Metal_Forgyldt' || tag == 'Forgyldt' || tag.toLowerCase().indexOf('vergoldet') > 0){
              color_image =  color_version ? '#d8c897' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_gold.png';
              color_group = 'cw_gold';
              break;
            }
            
            if(tag.toLowerCase().indexOf('Ruthenium') > 0 ||  tag == 'Metal_Rutheniumbelagt' || tag == 'Rutheniumbelagt'){
              color_image =  color_version ? '#666' : 'https://cdn.shopify.com/s/files/1/0574/3152/3417/t/2/assets/color_cw_black.png';
              color_group = 'cw_black';
              break;
            }
          }
        }
        
        var featured_image = the_prod.featured_image;
        var flip_image = the_prod.images[1];
        var is_selected = 'not-selected';

        // Set class for selected element
        if(the_prod.handle == selected_handle){
          var is_selected = 'selected';
        }

        // Check if the product is on sale and create a new price if true
        if( check_offer_number != 0 ){
          var saved_amount = (the_prod.price/100)*check_offer_number;
          var element_price = (the_prod.price-saved_amount);
          var old_price = the_prod.price.toFixed(2)/100;
          element_price = element_price.toFixed(2)/100;
        }else{
          var element_price = the_prod.price.toFixed(2)/100;;
        }

        // Refresh html element
        html = '';
        if( color_version ){
          if( typeof(color_image) == 'undefined' ){
            color_image = '#d6d6d6';
          }

          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<div '+'style="background:'+color_image+';" color="'+color_image+'" class="color_swatch fittingbox-select"'+ 
              'data-id="'+the_prod.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+the_prod.title+'" data-url="/products/'+the_prod.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+the_prod.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+the_prod.handle+'">'+
              '</div>'+
          '</a>';
        }else{
          html +=
          ' <a href="javascript:void(0)" class="js-class js-item '+is_selected+'">'+
              '<img '+'src="'+color_image+'" class="color_swatch fittingbox-select" data-frame="{{ product_frame }}"'+ 
              'data-id="'+the_prod.id+'" data-main-id="'+main_id+'"'+
              'data-title="'+the_prod.title+'" data-url="/products/'+the_prod.handle+'" data-old-price="'+old_price+'" data-price="'+element_price+'"'+
              'data-max-price="'+the_prod.price_max+'" data-img="'+featured_image+'" data-flip-img="'+flip_image+'"'+
              'data-color-group="'+color_group+'" data-selected-handle="'+the_prod.handle+'"'+
              '/>'+
          '</a>';
        }
        
        i++;
        $(list).append(html);
      });
    }, 900);
  });
}

// Function that retrieves the current collection sold out productsz
function get_current_collection_sold_out_prodcuts(){
  if( $('#sold-out-collection').length > 0){
    setTimeout(() => {
      
      // Get url parameters to check page number
      const queryString         = window.location.search;
      const urlParams           = new URLSearchParams(queryString);
      const page_param          = urlParams.get('page')
      const sold_out_container  = document.querySelector("#sold-out-collection");
      const max_page            = sold_out_container.dataset.pagesize; 
      const offer_collection    = "";
      const offer_number        = 50;
      
      // Check if we are on the last page og pagination
      if( page_param == max_page || max_page == 1 ){
        // Call the function with the collection handle and API access token
        getProductsInCollection(location.pathname, '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')
        .then(products => {
          // Loop through the array of products and do something with each one
          var html      = "";
          for (let i = 0; i < products.length; i++) {
            // Assign the individual product
            const product = products[i];
            const variant_count = product.variants.length;
            var splash    = "";
            
            // Get the text for the splashes
            if ( product.tags.includes("4 mm") && product.product_type == "Charms" ) {
              splash = '<div data-first-splash="true" class="grid-product__tag grid-product__tag--plus-size first-splash splash-design-round" style="background-color:#a3a1a1; color: #ffffff;font-size:12px; ">'+
              '<p>Til slimlæder &amp; <br>sølvarmbånd</p>'+
              '</div>';
            }
            if ( product.tags.includes("6 mm") && product.product_type == "Charms" ) {
              splash = '<div data-second-splash="true" class="grid-product__tag grid-product__tag--second-tag second-splash splash-design-round move-down" style="background-color:#000000; color: #ffffff;font-size:12px;  ">'+
              '<p>Til Classic <br>læderarmbånd</p>'+
              '</div>';
              
            }
            
            console.log('number of variants: '+variant_count);
            // Check if the product is available
            if (variant_count <= 1) {
              for (let n = 0; n < product.variants.length; n++) {
                const variant = product.variants[n];
                var featured_image = "https://cdn.shopify.com/s/files/1/0821/7454/2143/files/logo.png?v=1693904133";
                if (product.images[0] && product.images[0].src ) {                  
                  featured_image = product.images[0].src;
                }
          
                if (variant.available == false ) {
                  html += '<li class="grid__item custom__grid" data-handle="'+product.handle+'">'+
                    '<div class="card-wrapper underline-links-hover">'+
                      '<div class="card card--standard  card--media" style="--ratio-percent: 100%;">'+
                        '<div class="card__inner innder_card22 color-background-2 gradient ratio" style="--ratio-percent: 100%;">'+
                          splash+
                          '<div class="card__media" style="width:100%">'+
                            '<div class="media media--transparent media--hover-effect">'+
                              '<img style="object-fit: contain;" src="'+featured_image+'" alt="You and Me Charms til sølvarmbånd - CHRISTINA" class="motion-reduce main-image" width="2000" height="2000">'+
                            '</div>'+
                          '</div>'+
                          '<div class="card__content">'+
                            '<div class="card__information">'+
                              '<h3 class="card__heading">'+
                                '<a href="/products/'+product.handle+'" id="" class="full-unstyled-link main-product-link"">'+product.title+'</a>'+
                              '</h3>'+
                            '</div>'+
                            '<div class="card__badge top right"><span class="badge font-weight-500 color-grey">Udsolgt</span></div>'+
                          '</div>'+
                        '</div>'+
                        '<div class="card__content">'+
                          '<div class="card__information">'+
                            '<h3 class="card__heading h5" id="">'+
                              '<a href="/products/'+product.handle+'" id="" class="full-unstyled-link" aria-labelledby="">'+product.title+'</a>'+
                            '</h3>'+
                          '<div class="card-information">'+
                            '<div class="price  price--sold-out " data-offer-collection="'+offer_collection+'" data-offer-number="'+offer_number+'">'+
                              '<div class="price__container">'+
                                '<div class="price__old" style="display:none;">'+
                                  '<span class="price-item price-item--old">'+variant.price+'</span>'+
                                '</div>'+
                                '<div class="price__regular">'+
                                  '<span class="price-item price-item--regular">'+variant.price+'</span>'+
                                '</div>'+
                              '</div>'+
                            '</div>'+
                          '</div>'+
                        '</div>'+
                      '</div>'+
                    '</div>'+
                  '</li>';
                }
              }
            }
            
          }
          $(sold_out_container).append(html);
        })
        .catch(error => console.error(error));
      }
    }, 500);
  }
}

/**
 * Recursive funtion to get all products in a current collection
 * @param {*string} collectionHandle 
 * @param {*string} accessToken 
 * @param {*array} products 
 * @param {*Int} page 
 * @returns 
 */
function getProductsInCollection(collectionHandle, accessToken, products = [], page = 1) {
  return fetch(`${collectionHandle}/products.json?limit=50&page=${page}&access_token=${accessToken}`)
  .then(response => response.json())
  .then(productsPage => {
    // Concatenate the new products with the previous ones
    products = products.concat(productsPage.products);

    // Check if there are more products available
    if (productsPage.products.length === 50) {
      // Recursively call the function to get the next page of products
      return getProductsInCollection(collectionHandle, accessToken, products, page + 1);
    } else {
      // Return the final list of products when there are no more pages
      return products;
    }
  })
  .catch(error => console.error(error));
}

/**
 * Returns data in a specific collection
 * @param {*String} access_token 
 * @param {*String} domain 
 * @param {*String} product_handle 
 */
function return_product_collection(access_token, domain, product_handle){
  console.log('gettings collections');
  const client = ShopifyBuy.buildClient({
    storefrontAccessToken: access_token,
    domain: domain
  });
  
  client.product.fetchByHandle(product_handle).then(product => {
    const collectionEdges = product.collections.edges;
    const collections = collectionEdges.map(edge => edge.node);

  }).catch(error => console.error(error));
}





$('.iframe-full-height').on('load', function(){
  this.style.height=this.contentDocument.body.scrollHeight +'px';
});

/**
 * Function to get metafild values
 * @param {*string} handle 
 * @param {*string} namespace 
 * @param {*string} key 
*/
function get_metafield_value(handle, namespace, key) {
  const url = "https://christina-b2b.myshopify.com/api/2022-01/graphql.json";
  const storefrontAccessToken = 'cfe2d8c03c4b734d24842840b632f1de';
  const query = `
  {
    productByHandle(handle: "${handle}") {
      title
      metafield(namespace: "${namespace}", key: "${key}") {
        value
      }
    }
  }
  `;

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: query
  })
  .then(response => response.json())
  .then(data => {
      const metafieldValue = data.data.productByHandle.metafield.value;
      return metafieldValue;
  });
}


/**
 * Controls the inventory data  
 * @param {*string} value 
 */
function product_inventory_functionality(value) {

  // The container which hold the initial data
  // like {{product.handle}}, {{product.id}} etc
  const element_data = document.querySelector('.product__info-container');
  
  if (!element_data) return;

  let default_variant = element_data.getAttribute('data-only-default') === 'true';
  const initial_id = element_data.getAttribute('data-id');
  const parent_handle = element_data.getAttribute('data-product-handle');
  
  if (typeof value === "undefined") {
    default_variant = true;
  }

  // Fetch the product data - Check for variant values
  fetch(`/products/${parent_handle}.js`)
  .then(response => response.json())
  .then(product => {
      let variant_id;
      
      if (!default_variant) {
        const variant = product.variants.find(v =>
          v.option1 === value || 
          v.option2 === value || 
          v.option3 === value
        );
        
        if (variant) {
          variant_id = variant.id;
        }
      } else {
        variant_id = initial_id;
      }

      const inventory_element = document.getElementById('inventory-element');
      
      if (inventory_element) {
        const colorElement = inventory_element.querySelector('.inventory-color');
        const textElement = inventory_element.querySelector('.inventory-text');
        
        if (check_stock_status(product.id, variant_id)) {
          if (colorElement) {
            colorElement.classList.add('in-stock');
            colorElement.classList.remove('out-of-stock');
          }
          if (textElement) textElement.innerText = "På lager";
        } else {
          if (colorElement) {
            colorElement.classList.add('out-of-stock');
            colorElement.classList.remove('in-stock');
          }
          if (textElement) textElement.innerText = "I restordre - Forvent længere leveringstid";
        }
      }
  })
  .catch(error => console.error('Error fetching product:', error));
}


/**
 * Check stock status 
 * THis does not work unless commented script below is present on product page
 * It also needs the foreach radio-btn 
 * @param {*string} productId 
 * @param {*string} variantId 
 * @returns true if in stock
 */
function check_stock_status(productId, variantId) {
  console.log('Inside check');
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const quantity = window.inventories[productId][variantId].quantity;
      console.log('Quantity: '+ quantity);
      console.log(quantity > 0);
      return quantity > 0;
  }
  return false;
}
 
/**
 * Output inventorydata
 * @param {*string} productId 
 * @param {*string} variantId 
 */
function display_inventory_data(productId, variantId) {
  if (window.inventories[productId] && window.inventories[productId][variantId]) {
      const inventory = window.inventories[productId][variantId];
      console.log("Quantity:", inventory.quantity);
      console.log("Policy:", inventory.policy);
      console.log("Incoming:", inventory.incoming);
      console.log("Next Incoming Date:", inventory.next_incoming_date);
  } else {
      console.log("No inventory data found for the specified product and variant.");
  }
}

/**
 * Implements hotspot functionality for product-hot-spot section
 */
function hotspot_functionality(){
  //var hotspot = querySelector('.hotspot-item'); 
  document.querySelectorAll('.hotspot-item').forEach(function(item) {
    item.addEventListener('click', function(event) {
        // Getting the 'data-id' attribute from the hotspot item
        const hotspotDataId = item.getAttribute("data-id");
        console.log(hotspotDataId);
        if (!hotspotDataId) {
            console.error('Data ID not found in hotspot item.');
            return;
        }
  
        try {
            // Extracting information with null checks
            const imgElement = item.querySelector('img');
            const preview_image = imgElement ? imgElement.getAttribute('src') : 'DefaultImagePath';
  
            const linkElement = item.querySelector('a');
            const url = linkElement ? linkElement.getAttribute('href') : 'DefaultURL';
  
            const contentElement = item.querySelector('.product-title');
            const content = contentElement ? contentElement.innerText : 'DefaultContent';
  
            const priceElement = item.querySelector('.prod-price');
            const price = priceElement ? priceElement.innerText : 'DefaultPrice';
  
            // Finding the '.side-product' container corresponding to this data-id
            var target_container = document.querySelector('.side-product-section-' + hotspotDataId);
            if (!target_container) {
                console.error('Side product container for data-id ' + hotspotDataId + ' not found.');
                return; // Exit the function if the container is not found
            }
  
            // Updating elements within the '.side-product' container
            var target_image = target_container.querySelector('#side-product__preview-image');
            if (target_image) {
                target_image.src = preview_image;
            } else {
                console.error('Preview image element not found.');
            }
  
            var target_url = target_container.querySelector('.button');
            if (target_url) {
                target_url.href = url;
            } else {
                console.error('URL element not found.');
            }
  
            var target_content = target_container.querySelector('.title');
            if (target_content) {
                target_content.innerText = content;
            } else {
                console.error('Content element not found.');
            }
  
            var target_price = target_container.querySelector('.price span');
            if (target_price) {
                target_price.innerText = price;
            } else {
                console.error('Price element not found.');
            }
  
        } catch (error) {
            console.error('An error occurred:', error);
        }
    });
  });
}

window.addEventListener('load', function(e){
  hotspot_functionality();
  //display_inventory_data();

   // Functionality for language additions
   const langAdditions = document.querySelectorAll('.lang-addition');

   if (langAdditions.length > 0) {
     langAdditions.forEach(function (el) {
       el.addEventListener('click', function () {
         const href = el.getAttribute('data-href');
         if (href) {
           window.location.href = href;
         } 
       });
     });
   }

})